import React, {Component} from 'react'
import {connect} from 'react-redux'
import Svg from "react-svg-y";
import {Theme} from "theme-y";
import {_Object} from "react-utils-y";
import {pageSty} from './style'

let getTheme = (_this) => {
    // designationTheme  指定的主题，  theme  redux设置的全局主题,
    let themeName = _this.props.theme || "default";
    return _this.state.theme[themeName].page
};
class PageComponent extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            flag: 0,
            current: 1,      //当前页码
            pageSize: 10,    //每页显示的条数5条
            goValue: '',     //点击跳转的值
            totalNum: 0,     //总记录数
            totalPage: 0,    //总页数
            showList: false
        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    pageClick = (pageNum, type) => {
        if (pageNum != this.state.current) {
            this.setState({
                current: pageNum,
                flag: type == 1 ? 1 : 0
            });
        }
        let _this = this;
        setTimeout(function () {
            _this.props.handlePage(pageNum)
        }, 100)
    };

    handlePrev = () => {
        let cur = this.state.current;
        if (cur > 1) {
            this.pageClick(cur - 1);
        }
    };

    handleNext = () => {
        let cur = this.state.current;
        if (cur < this.state.totalPage) {
            this.pageClick(cur + 1);
        }
    };

    setGoValue = (e) => {
        this.setState({goValue: e.target.value});
    };

    handleInputPage = () => {
        let value = this.state.goValue;
        if (!/^[1-9]\d*$/.test(value)) {
            //alert('页码只能输入大于1的正整数');
            console.log('页码只能输入大于1的正整数')
        } else if (parseInt(value) > parseInt(this.state.totalPage)) {
            //alert('没有这么多页');
            console.log('没有这么多页')
        } else {
            this.pageClick(value, 1);
        }
    };

    handleChoose = (e) => {
        var myselect = document.getElementById('pageSize');
        var index = myselect.selectedIndex;
        let pagesize = myselect.options[index].value;
        this.setState({
            pageSize: pagesize,
            totalPage: Math.ceil(this.state.totalNum / pagesize), // 总页数
            showList: !this.state.showList
        });
        console.log(Number(e.target.innerText))
    };
    handleOver = () => {
        this.setState({
            showList: true
        })
    };
    handleOut = () => {
        this.setState({
            showList: false
        })
    };

    componentWillMount() {
    }

    componentDidMount() {
        let pagesize = this.props.pageSize || 10;
        this.setState({
            pageSize: pagesize, // 每页数目
            oldPageSize: pagesize,
            totalNum: this.props.totalNum, // 总记录数
            current: this.props.pageNumber, // 当前页码
            totalPage: Math.ceil(this.props.totalNum / pagesize), // 总页数
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.oldPageNumber != nextProps.pageNumber) {
            this.setState({
                current: nextProps.pageNumber, // 当前页码
            })
        }
        this.setState({
            //goValue: nextProps.pageNumber == 1 ? nextProps.pageNumber : this.state.flag == 1 ? this.state.goValue : nextProps.pageNumber,
            goValue: "",
            totalNum: nextProps.totalNum, // 总记录数
            totalPage: Math.ceil(nextProps.totalNum / this.state.pageSize), // 总页数
        });
    };

    render() {
        let styles = _Object.merge({}, pageSty(getTheme(this)));
        //当前页码
        let cur = this.state.current;
        //显示分页按钮
        let pageNum = [];
        let begin;
        let len;
        if (this.state.totalPage > 5) {
            len = 5;
            if (cur >= (this.state.totalPage - 2)) {
                begin = this.state.totalPage - 4;
            } else if (cur <= 3) {
                begin = 1;
            } else {
                begin = cur - 2;
            }
        } else {
            len = this.state.totalPage;
            begin = 1;
        }
        //根据返回的总记录数计算当前页显示的数据
        for (let i = 0; i < len; i++) {
            let cur = this.state.current;
            let showI = begin + i;
            if (cur == showI) {
                pageNum.push({num: showI, cur: true});
            } else {
                pageNum.push({num: showI, cur: false});
            }
        }
        let _this = this;
        return (
            <div style={styles.pageBox}>

                <div style={styles.pageNumBox}>
                    <a style={this.state.current == 1 ? styles.pagebtnDisabled : styles.pagebtnBox}
                       onClick={this.handlePrev}>
                        {"<"}
                    </a>
                    <span style={styles.pageNumCont}>
                        {pageNum.map(function (curPageNum, i) {
                            return (
                                <a style={curPageNum.cur ? styles.currentNum : styles.numBox}
                                   onClick={_this.pageClick.bind(_this, curPageNum.num)}
                                   key={i}>
                                    {curPageNum.num}
                                </a>
                            )
                        })}
                    </span>
                    <a style={this.state.current == this.state.totalPage ? styles.pagebtnDisabled : styles.pagebtnBox}
                       onClick={this.handleNext}>
                        {">"}
                    </a>
                </div>
                <div style={styles.textBox}>
                    总共 <label style={styles.labelN}> {this.state.totalNum} </label> 条
                    每页
                    <div style={styles.pageSizeBox}
                         onMouseOver={this.handleOver}
                         onMouseOut={this.handleOut}
                    >
                        <select id="pageSize" onChange={this.handleChoose} style={styles.pageSize}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        <span style={styles.svg}>
                            <Svg type="Bottom" width="1rem" height="1rem" fill="#ccc"/>
                        </span>
                    </div>
                    条
                    <label style={styles.labelN}>共{this.state.totalPage}页</label>
                    到第<input type="text" style={styles.inputBox} value={this.state.goValue}
                             onChange={this.setGoValue}/>页
                    <span style={styles.jumpBox} onClick={this.handleInputPage}>Go</span>
                </div>

            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageComponent)